import React from 'react';
import { Button } from '@material-ui/core';
import { SnackbarKey, useSnackbar } from 'notistack';

const undoAction = (undo: () => void, close: (key: SnackbarKey) => void) => (key: SnackbarKey) => (
  <Button
    color="secondary"
    size="small"
    onClick={() => {
      undo();
      close(key);
    }}
  >
    Отменить
  </Button>
);

/** Тост окна оценки; с `undo` — кнопка «Отменить». */
export function useRatingToast() {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  return (message: string, undo?: () => void) => {
    enqueueSnackbar(message, { action: undo ? undoAction(undo, closeSnackbar) : undefined });
  };
}
